import concat from 'lodash/concat'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, reroute, storeDumpItForce } from '../../../actions/Buy'
import {
  clearFinanziamentoAssicurato,
  getFindomesticServiziAssicurativi,
  getProdottiAssicurativiFromIdPianoRimborsoOutput,
  postFindomesticCalcolatriceAssicurazioni,
  postFindomesticSetPratica,
  selectServizioAssicurativo,
  setDurataServizioAssicurativo,
  unSelectAllServiziAssicurativi,
  unSelectServizioAssicurativo,
} from '../../../actions/buy/Findomestic'
import { errorNotice } from '../../../actions/ErrorNotice'
import { AssurancesSettingsHelper } from '../../../helpers/assurances/settings'
import { FinancingSettingsHelper } from '../../../helpers/financing/settings'
import {
  getCodiceServizioByUid,
  getMensilitaCopertura,
  getSelectedFinanziamento,
  getServizioAssicurativoUid,
  getServizioByUid,
} from '../../../utils/findomesticUtils'
import { getFinanziamentoNonAssicurato } from '../../../utils/firmaUtils'
import OrderRecoveryBanner from '../../dumb/OrderRecoveryBanner'
import BuyCheckboxInput from '../dumb/BuyCheckboxInput'
import BuyMiniCart from '../dumb/BuyMiniCart'
import BuyModal from '../dumb/BuyModal'
import BuyRateBox from '../dumb/BuyRateBox'
import BuySelectInput2 from '../dumb/BuySelectInput2'
import BuyTextInput2 from '../dumb/BuyTextInput2'
import { preparaValoriLogistica, proxifyEcreditUrl } from '../utils'

class RiepilogoFinanziamentoFindomestic extends Component {
  constructor(props) {
    super(props)

    const promptErrorModal = (title, description) =>
      this.props.errorNotice({
        logo: 'dati_non_corretti',
        message:
          description || "E' necessario selezionare almeno un'assicurazione",
        title: title || 'Selezione non corretta',
        type: 'custom',
      })

    this.state = {
      selectedFinanziamento: {},
      servizi_changed: false,
      questionario: {},
      canContinue: true,
      riepilogo_finanziamento_tooltip_modal: false,
      assurancesSettingsHelper: new AssurancesSettingsHelper(
        props.ui.sellout_settings_acquista &&
          props.ui.sellout_settings_acquista.assicurazioni_settings,
        promptErrorModal
      ),
      financingSettingsHelper: new FinancingSettingsHelper(
        props.ui.sellout_settings_acquista?.finanziamento_settings,
        props.financements
      ),
    }
    this.toggleRateInfo = this.toggleRateInfo.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleRicalcola = this.handleRicalcola.bind(this)
    this.selectedFinanziamento = this.selectedFinanziamento.bind(this)
    this.handleSelezionaServizioAssicurativo =
      this.handleSelezionaServizioAssicurativo.bind(this)
    this.isServizioAssicurativoChecked =
      this.isServizioAssicurativoChecked.bind(this)
    this.buildQuestionario = this.buildQuestionario.bind(this)
    this.handleRadioQuestionario = this.handleRadioQuestionario.bind(this)
    this.validateDomandaQuestionario =
      this.validateDomandaQuestionario.bind(this)
    this._getServizioByUid = this._getServizioByUid.bind(this)
    this._getMensilitaCopertura = this._getMensilitaCopertura.bind(this)
    this.handleDurataServizio = this.handleDurataServizio.bind(this)
    this.servizioIsCompatibleWithSelected =
      this.servizioIsCompatibleWithSelected.bind(this)
    this.setDefaultChecked = this.setDefaultChecked.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  async componentDidMount() {
    this.props.phaseChange({ phase: 40, last: 30 })
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')

      return
    }

    try {
      const json = await this.props.getFindomesticServiziAssicurativi()
      if (json.result && json.result.length) {
        this.props.clearFinanziamentoAssicurato({})
        this.selectedFinanziamento()

        this.props.rerouteTo('/riepilogo-finanziamento-findomestic')
        this.props.storeDumpItForce()
        await this.setDefaultChecked()
      } else {
        this.props
          .postFindomesticSetPratica()
          .then(() => this.props.reroute('/documents-findomestic'))
      }
    } catch (err) {
      this.props
        .postFindomesticSetPratica()
        .then(() => this.props.reroute('/documents-findomestic'))
    }

    if (
      this.state.financingSettingsHelper.isFinancingOnlyQuotation &&
      this.state.financingSettingsHelper.hasInsuranceProducts
    ) {
      const questionarioSelectedProducts = {}
      for (const productUid of this.state.financingSettingsHelper.mapSelectedFindomesticProducts(
        this.props.findomestic.servizi_assicurativi
      )) {
        questionarioSelectedProducts[productUid] = {}
      }

      this.setState({
        questionario: questionarioSelectedProducts,
      })
    }
  }

  componentDidUpdate() {
    this.selectedFinanziamento()
  }

  _getMensilitaCopertura(servizio) {
    return getMensilitaCopertura(
      servizio,
      this.props.ordine,
      this.props.financements,
      this.props.findomestic
    )
  }

  setDefaultChecked() {
    const fn = async item => {
      this.props.selectServizioAssicurativo(item)
      this.setState({
        servizi_changed: true,
        questionario: {
          ...this.state.questionario,
          [getServizioAssicurativoUid(item)]: {},
        },
      })

      await this.handleRicalcola()
    }

    return this.state.assurancesSettingsHelper.setDefaultChecked(
      this.props.findomestic.servizi_assicurativi,
      fn
    )
  }

  isAssurancesChoicesValid(assurancesSelected) {
    return this.state.assurancesSettingsHelper.isValid(
      assurancesSelected.map(uid =>
        getServizioByUid(uid, this.props.findomestic.servizi_assicurativi)
      )
    )
  }

  handleInvalidChoices() {
    this.state.assurancesSettingsHelper.errors.raise()
  }

  handleSubmit() {
    if (
      !this.isAssurancesChoicesValid(
        this.props.findomestic.servizi_assicurativi_selezionati
      )
    ) {
      this.handleInvalidChoices()

      return
    }

    const validateQuestionari = this.getSelectedServiziAssicurativi().reduce(
      (acc, current) => {
        // per ogni servizio selezionato controllo che
        // 1) al quantita' di consensi sia uguale
        // 2) che siano tutti true
        const servizio = this._getServizioByUid(current) // servizio corrente
        const clausesAdeguatezza =
          servizio.questionario_adeguatezza &&
          servizio.questionario_adeguatezza.clauses &&
          servizio.questionario_adeguatezza.clauses.length
            ? servizio.questionario_adeguatezza.clauses.length
            : 0
        const clausesMedico =
          servizio.questionario_medico &&
          servizio.questionario_medico.clauses &&
          servizio.questionario_medico.clauses.length
            ? servizio.questionario_medico.clauses.length
            : 0
        const clausesCount = clausesMedico + clausesAdeguatezza // totale domande questionario per tale servizio
        const accepted = Object.values(this.state.questionario[current]).filter(
          answer => answer
        ) // domande alle quali si e' dato consenso
        if (clausesCount !== accepted.length) {
          // se non sono tutto metto nell'accumulatore il servizioUid
          acc.push(current)
        }
        return acc
      },
      []
    )

    if (validateQuestionari.length) {
      // non ci sono tutti i consensi
      this.props.errorNotice({
        type: 'custom',
        message:
          'Impossibile proseguire: alcune risposte non sono state fornite o non sono compatibili con i prodotti selezionati',
        title: 'Questionario obbligatorio',
        logo: 'dati_non_corretti',
      })
    } else {
      // ci sono tutti i consensi
      this.props
        .postFindomesticSetPratica()
        .then(() => this.props.reroute('/documents-findomestic'))
    }
  }

  _getServizioByUid(servizioUid) {
    return getServizioByUid(
      servizioUid,
      this.props.findomestic.servizi_assicurativi
    )
  }

  async handleRicalcola() {
    try {
      await this.props.postFindomesticCalcolatriceAssicurazioni()
      await this.props.getProdottiAssicurativiFromIdPianoRimborsoOutput()
      this.setState({ servizi_changed: false })
    } catch (err) {
      this.props.unSelectAllServiziAssicurativi({})
      this.setState({
        servizi_changed: false,
        questionario: {},
      })
    }
  }

  selectedFinanziamento() {
    if (
      this.props.findomestic &&
      this.props.findomestic.finanziamentoAssicurato &&
      this.props.findomestic.finanziamentoAssicurato.id_finanziamento
    ) {
      if (
        this.state.selectedFinanziamento &&
        this.props.findomestic.finanziamentoAssicurato.id_finanziamento !==
          this.state.selectedFinanziamento.id_finanziamento
      ) {
        this.setState({
          selectedFinanziamento: this.props.findomestic.finanziamentoAssicurato,
        })
      }
      return
    }
    const newFinanziamento = getSelectedFinanziamento(
      this.props.ordine,
      this.props.financements
    )

    if (
      newFinanziamento &&
      this.state.selectedFinanziamento &&
      newFinanziamento.id_finanziamento !==
        this.state.selectedFinanziamento.id_finanziamento
    ) {
      this.setState({
        selectedFinanziamento: newFinanziamento,
      })
    }
  }

  handleSelezionaServizioAssicurativo(servizio, deselectAll) {
    return event => {
      const servizioUid = getServizioAssicurativoUid(servizio)
      const isChecked = event.target.checked

      if (
        !isChecked &&
        this.state.assurancesSettingsHelper.isMandatoryChecked
      ) {
        const choices = JSON.parse(
          JSON.stringify(
            this.props.findomestic.servizi_assicurativi_selezionati
          )
        )
        choices.splice(choices.indexOf(servizioUid), 1)
        if (!this.isAssurancesChoicesValid(choices)) {
          this.handleInvalidChoices()

          return
        }
      }

      if (isChecked) {
        this.props.selectServizioAssicurativo(servizio)
        this.setState({
          servizi_changed: true,
          questionario: { ...this.state.questionario, [servizioUid]: {} },
        })
        this.handleRicalcola().then(() => {})

        return
      }

      this.props.unSelectServizioAssicurativo(servizio)
      const currentQuestionario = this.state.questionario
      delete currentQuestionario[servizioUid]
      this.setState({
        servizi_changed: true,
        questionario: currentQuestionario,
      })

      if (Object.keys(currentQuestionario).length && !deselectAll) {
        // se avanzano questionari vuol dire
        // che ci sono prodotti assicurativi selezionati
        // e quindi bisogna ricalcolare
        this.handleRicalcola().then(() => {})
      }
    }
  }

  isServizioAssicurativoChecked(servizio) {
    return (
      this.isOnlyQuotationInsuranceProductIncluded(servizio) ||
      this.props.findomestic.servizi_assicurativi_selezionati.includes(
        getServizioAssicurativoUid(servizio)
      )
    )
  }

  isOnlyQuotationInsuranceProductIncluded(product) {
    return (
      this.state.financingSettingsHelper.isFinancingOnlyQuotation &&
      this.state.financingSettingsHelper.hasInsuranceProducts &&
      this.state.financingSettingsHelper.includeProduct(product)
    )
  }

  isOnlyQuotationInsuranceProductNotIncluded(product) {
    return (
      this.state.financingSettingsHelper.isFinancingOnlyQuotation &&
      this.state.financingSettingsHelper.hasInsuranceProducts &&
      !this.state.financingSettingsHelper.includeProduct(product)
    )
  }

  buildQuestionario(servizio) {
    const clausesAdeguatezza =
      servizio.questionario_adeguatezza &&
      servizio.questionario_adeguatezza.clauses
        ? servizio.questionario_adeguatezza.clauses
        : []
    const clausesMedico =
      servizio.questionario_medico && servizio.questionario_medico.clauses
        ? servizio.questionario_medico.clauses
        : []

    const clauses = concat(clausesAdeguatezza, clausesMedico)

    return !clauses.length ? null : (
      <div>
        {clauses.map(domanda => {
          const servizioUid = getServizioAssicurativoUid(servizio)
          const radioName = `${servizioUid}_${domanda.group}_${domanda.id}`
          const risposte = domanda.risposte || [
            { id: '1', text: 'Si', required: 'true' },
            { id: '2', text: 'No', required: 'false' },
          ]
          return (
            <div key={domanda.id}>
              <div dangerouslySetInnerHTML={{ __html: domanda.text }} />
              <p style={{ textAlign: 'center' }}>
                {risposte.map(risposta => (
                  <label className={'r-checkbox radio'} key={risposta.id}>
                    <input
                      defaultChecked={false}
                      name={radioName}
                      onChange={() =>
                        this.handleRadioQuestionario(
                          radioName,
                          servizio,
                          domanda,
                          risposta.required === 'true'
                        )
                      }
                      type="radio"
                      value={risposta.required === 'true' ? '1' : '0'}
                    />
                    <span className={'radio'}></span>
                    {risposta.text}
                  </label>
                ))}
              </p>
            </div>
          )
        })}
      </div>
    )
  }

  handleRadioQuestionario(radioName, servizio, domanda, consenso) {
    const servizioUid = getServizioAssicurativoUid(servizio)
    const questionarioServizio = this.state.questionario[servizioUid]
    questionarioServizio[radioName] = consenso

    this.setState({
      questionario: {
        ...this.state.questionario,
        [servizioUid]: questionarioServizio,
      },
    })
  }

  validateDomandaQuestionario(servizioUid, radioName) {
    if (
      this.state.questionario[servizioUid] !== undefined &&
      this.state.questionario[servizioUid][radioName] !== undefined
    ) {
      // se e' selezionato il servizio
      // deve essere checkato il consenso
      return this.state.questionario[servizioUid][radioName]
    }
    // se non e' settata il servizio assicurativo
    // non e' selezionato e quindi tutto ok
    return true
  }

  handleDurataServizio(servizio) {
    const t = this
    return e => {
      const durata = e ? e.value : null
      if (durata) {
        t.props.setDurataServizioAssicurativo({ durata, servizio })
      }
    }
  }

  servizioIsCompatibleWithSelected(servizio) {
    const serviziKo =
      servizio.vincolo_prodotti && servizio.vincolo_prodotti.KO
        ? servizio.vincolo_prodotti.KO
        : []
    const selectedCodiciServizi =
      this.props.findomestic.servizi_assicurativi_selezionati.map(s =>
        getCodiceServizioByUid(s)
      )

    return (
      serviziKo.filter(ko => selectedCodiciServizi.includes(ko)).length === 0
    )
  }

  toggleRateInfo() {
    this.setState({
      riepilogo_finanziamento_tooltip_modal:
        !this.state.riepilogo_finanziamento_tooltip_modal,
    })
  }

  getSelectedServiziAssicurativi() {
    if (
      this.state.financingSettingsHelper.isFinancingOnlyQuotation &&
      this.state.financingSettingsHelper.hasInsuranceProducts
    ) {
      return this.state.financingSettingsHelper.mapSelectedFindomesticProducts(
        this.props.findomestic.servizi_assicurativi
      )
    }

    return this.props.findomestic.servizi_assicurativi_selezionati
  }

  render() {
    const { product } = this.props
    const valoriLogistica = preparaValoriLogistica(
      this.props.pricing.total,
      this.props.logistica
    )

    let { selectedFinanziamento } = this.state
    if (
      selectedFinanziamento &&
      !!this.props.findomestic.finanziamentoAssicurato.id_finanziamento &&
      !!selectedFinanziamento.id_finanziamento &&
      this.props.findomestic.finanziamentoAssicurato.id_finanziamento !==
        selectedFinanziamento.id_finanziamento
    ) {
      selectedFinanziamento = this.props.findomestic.finanziamentoAssicurato
    }

    return (
      <section className="relative process riepilogo-finanziamento">
        <div className="process__header">
          <h1 className="process__title">
            Riepilogo richiesta di Finanziamento
          </h1>
        </div>
        <div className={'messages warning'}>
          <div className={'container'}>
            <OrderRecoveryBanner />
          </div>
        </div>
        <div className="user-informations">
          <div className="container_small">
            <div className="process__column process__column__left">
              <ul>
                <li className="wide buttons">
                  {this.props.findomestic.servizi_assicurativi && (
                    <div className="process__column ">
                      <h5 className="section-title --reduced no-padding">
                        Vuoi aggiungere coperture al prestito?
                      </h5>
                      <div className="box-elementi">
                        {this.props.findomestic.servizi_assicurativi.map(
                          servizio => {
                            if (
                              this.state.assurancesSettingsHelper.isHidden(
                                servizio
                              )
                            ) {
                              return null
                            }

                            if (
                              this.isOnlyQuotationInsuranceProductNotIncluded(
                                servizio
                              )
                            ) {
                              return null
                            }

                            const label = (
                              <div
                                className="paragraph"
                                key={`${servizio.id}_inner`}
                                style={{ paddingBottom: '20px' }}
                              >
                                <b className="text-grigio">
                                  <b className="mini-title text-nero">
                                    {servizio.titolo}
                                  </b>
                                </b>
                              </div>
                            )
                            return (
                              <div className={'box-service'} key={servizio.id}>
                                <div className={'box-wrapper'}>
                                  <BuyCheckboxInput
                                    checked={
                                      this.isServizioAssicurativoChecked(
                                        servizio
                                      ) ||
                                      this.isOnlyQuotationInsuranceProductIncluded(
                                        servizio
                                      )
                                    }
                                    classes={'r-checkbox long'}
                                    disabled={
                                      !this.servizioIsCompatibleWithSelected(
                                        servizio
                                      ) ||
                                      this.state.assurancesSettingsHelper.isDisabled(
                                        servizio
                                      ) ||
                                      this.isOnlyQuotationInsuranceProductIncluded(
                                        servizio
                                      )
                                    }
                                    key={servizio.id}
                                    label={[label]}
                                    update={this.handleSelezionaServizioAssicurativo(
                                      servizio
                                    )}
                                    value={this.isServizioAssicurativoChecked(
                                      servizio
                                    )}
                                  />
                                  {servizio.vincolo_multiplo_mensilita ? (
                                    <ul className="data-form x-small active no-margin no-padding">
                                      {this.isOnlyQuotationInsuranceProductIncluded(
                                        servizio
                                      ) ? (
                                        <li className="wide">
                                          <BuyTextInput2
                                            classes="input-data form-input big"
                                            defaultValue={`${this.state.financingSettingsHelper.getProductDuration(
                                              servizio
                                            )} mesi`}
                                            disabled
                                            label="Durata copertura"
                                            update={() => null}
                                            value={`${this.state.financingSettingsHelper.getProductDuration(
                                              servizio
                                            )} mesi`}
                                          />
                                        </li>
                                      ) : (
                                        <BuySelectInput2
                                          clearable={false}
                                          defaultValue={
                                            servizio.selected_durata
                                              ? servizio.selected_durata
                                              : this._getMensilitaCopertura(
                                                  servizio
                                                ).pop()
                                          }
                                          disabled={
                                            this.isServizioAssicurativoChecked(
                                              servizio
                                            ) ||
                                            !this.servizioIsCompatibleWithSelected(
                                              servizio
                                            )
                                          }
                                          label="Durata copertura"
                                          liClassName={`wide`}
                                          update={this.handleDurataServizio(
                                            servizio
                                          )}
                                          values={this._getMensilitaCopertura(
                                            servizio
                                          ).map(v => ({
                                            label: `${v} mesi`,
                                            value: v,
                                          }))}
                                        />
                                      )}
                                    </ul>
                                  ) : null}
                                </div>
                                {this.servizioIsCompatibleWithSelected(
                                  servizio
                                ) ? null : (
                                  <p>
                                    <i>
                                      Prodotto non compatibile con quelli già
                                      selezionati
                                    </i>
                                  </p>
                                )}
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: servizio.descrizione,
                                  }}
                                ></p>
                                <a
                                  href={proxifyEcreditUrl(
                                    servizio.link_informativa
                                  )}
                                  rel="noreferrer"
                                  target="_blank"
                                >
                                  Scarica informativa
                                </a>
                              </div>
                            )
                          }
                        )}

                        {!this.state.assurancesSettingsHelper
                          .isMandatoryChecked &&
                          !this.state.assurancesSettingsHelper.isRequired &&
                          (!this.state.financingSettingsHelper
                            .isFinancingOnlyQuotation ||
                            !this.state.financingSettingsHelper
                              .hasInsuranceProducts) && (
                            <div className={'box-service'}>
                              <div className={'box-wrapper'}>
                                <BuyCheckboxInput
                                  checked={
                                    !this.props.findomestic
                                      .servizi_assicurativi_selezionati.length
                                  }
                                  classes={'r-checkbox long big'}
                                  label={[
                                    'No grazie, non voglio nessuna copertura aggiuntiva al prestito',
                                  ]}
                                  update={event => {
                                    if (event.target.checked) {
                                      this.props.findomestic.servizi_assicurativi.map(
                                        // eslint-disable-next-line
                                        servizio => {
                                          this.handleSelezionaServizioAssicurativo(
                                            servizio,
                                            true
                                          )({ target: { checked: false } })
                                        }
                                      )
                                      this.setState({ canContinue: true })
                                    } else {
                                      this.setState({ canContinue: false })
                                    }
                                  }}
                                  value={
                                    !this.props.findomestic
                                      .servizi_assicurativi_selezionati.length
                                      ? this.state.canContinue
                                      : false
                                  }
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                </li>

                <li className="wide buttons">
                  {this.props.findomestic.servizi_assicurativi_selezionati
                    .length ||
                  (this.state.financingSettingsHelper
                    .isFinancingOnlyQuotation &&
                    this.state.financingSettingsHelper.hasInsuranceProducts) ? (
                    <div className="process__column ">
                      <hr style={{ marginTop: '60px' }} />
                      <h3 className="section-subtitle">
                        Per procedere con l’acquisto rispondi a questo breve
                        questionario
                      </h3>
                      <div className="box-elementi">
                        {this.getSelectedServiziAssicurativi().map(
                          servizioUid => {
                            const servizio = this._getServizioByUid(servizioUid)
                            return (
                              <div key={servizioUid}>
                                {this.isServizioAssicurativoChecked(
                                  servizio
                                ) && (
                                  <div>
                                    <h4 style={{ fontWeight: 700 }}>
                                      {servizio.titolo} (
                                      {servizio.tipologia_prodotto})
                                    </h4>
                                    {this.buildQuestionario(servizio)}
                                  </div>
                                )}
                              </div>
                            )
                          }
                        )}
                      </div>
                    </div>
                  ) : null}
                </li>
                <li className="wide buttons" style={{ marginTop: '30px' }}>
                  <div className="process__column ">
                    <div className="next-button-wrapper-sticky text-center">
                      {selectedFinanziamento && (
                        <div
                          className={'next-canone-info'}
                          onClick={this.toggleRateInfo}
                        >
                          <b>
                            <small>
                              <span className={'canone-tan'}>
                                TAN fisso
                                <br />
                                {numeral(
                                  selectedFinanziamento.tan / 100
                                ).format('0.00%')}
                              </span>
                              <span className={'canone-taeg'}>
                                TAEG
                                <br />
                                {numeral(
                                  selectedFinanziamento.taeg / 100
                                ).format('0.00%')}
                              </span>
                              €{' '}
                            </small>
                            {numeral(selectedFinanziamento.importo_rata).format(
                              '0,0[.]00'
                            )}{' '}
                            al mese
                          </b>
                          <i className={'icon-info'} />
                          {!!this.state
                            .riepilogo_finanziamento_tooltip_modal && (
                            <BuyModal>
                              <div
                                className={
                                  'the-modal modal show modal-rate-box'
                                }
                              >
                                <div
                                  className="error__popup"
                                  style={{ width: 'auto', minWidth: '340px' }}
                                >
                                  <BuyRateBox
                                    acconti={this.props.ordine.acconti}
                                    calcolatrice={selectedFinanziamento}
                                    handleHover={() => {}}
                                    hideButton
                                    keyy={
                                      selectedFinanziamento.id_finanziamento
                                    }
                                    label={null}
                                    numeroRate={
                                      selectedFinanziamento?.numero_rate
                                    }
                                    selected={0}
                                    style={{ width: '100%' }}
                                  />

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      width: '100%',
                                    }}
                                  >
                                    <a
                                      className={'btn btn-secondary'}
                                      onClick={this.toggleRateInfo}
                                    >
                                      <span>CHIUDI</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </BuyModal>
                          )}
                        </div>
                      )}
                      <button
                        className="btn btn-primary js-next-step"
                        data-cy="summary-submit"
                        onClick={event => {
                          if (
                            !this.props.findomestic
                              .servizi_assicurativi_selezionati.length &&
                            !this.state.canContinue
                          ) {
                            return false
                          }
                          this.handleSubmit(event)
                        }}
                      >
                        <span>Inoltra richiesta</span>
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="process__column process__column__right">
              {this.state.selectedFinanziamento &&
              this.state.selectedFinanziamento.id_finanziamento ? (
                <BuyMiniCart
                  {...valoriLogistica}
                  acconti={this.props.ordine.acconti}
                  agevolazione_iva_104={
                    this.props.customer.agevolazione_iva_104
                  }
                  finanziamento={this.state.selectedFinanziamento}
                  finanziamentoNonAssicurato={getFinanziamentoNonAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  idAuto={product.id_auto}
                  km={product.km}
                  onlyFinanziamento
                  ordine={this.props.ordine}
                  ownership={product.passaggio_proprieta_totale_generale}
                  paymentMethod={'finanziamento_findomestic'}
                  price={this.props.ordine.auto_prezzo_sellout}
                  product={product}
                  sconto={this.props.ordine.sconto}
                  serviziAssicurativiSelezionati={
                    this.props.findomestic.servizi_assicurativi_selezionati
                  }
                  totalone={this.props.ordine.totale}
                  year={product.anno}
                />
              ) : null}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

RiepilogoFinanziamentoFindomestic.defaultProps = {}

RiepilogoFinanziamentoFindomestic.propTypes = {
  customer: PropTypes.object,
  logistica: PropTypes.object,
  ordine: PropTypes.object,
  financements: PropTypes.object,
  findomestic: PropTypes.object,
  pricing: PropTypes.object,
  product: PropTypes.object,
  reroute: PropTypes.func,
}

const mapStateToProps = state => ({
  customer: state.customer,
  logistica: state.logistica,
  financements: state.financements,
  findomestic: state.findomestic,
  ordine: state.ordine,
  pricing: state.pricing,
  product: state.product,
  ui: state.ui,
})

const mapDispatchToProps = dispatch => ({
  phaseChange: payload => dispatch(phaseChange(payload)),
  postFindomesticSetPratica: () => dispatch(postFindomesticSetPratica),
  getFindomesticServiziAssicurativi: () =>
    dispatch(getFindomesticServiziAssicurativi),
  getProdottiAssicurativiFromIdPianoRimborsoOutput: () =>
    dispatch(getProdottiAssicurativiFromIdPianoRimborsoOutput),
  postFindomesticCalcolatriceAssicurazioni: () =>
    dispatch(postFindomesticCalcolatriceAssicurazioni),
  unSelectServizioAssicurativo: payload =>
    dispatch(unSelectServizioAssicurativo(payload)),
  unSelectAllServiziAssicurativi: payload =>
    dispatch(unSelectAllServiziAssicurativi(payload)),
  selectServizioAssicurativo: payload =>
    dispatch(selectServizioAssicurativo(payload)),
  clearFinanziamentoAssicurato: payload =>
    dispatch(clearFinanziamentoAssicurato(payload)),
  setDurataServizioAssicurativo: payload =>
    dispatch(setDurataServizioAssicurativo(payload)),
  reroute: payload => dispatch(reroute(payload)),
  rerouteTo: to => dispatch({ type: 'SET_REROUTE', payload: to }),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  errorNotice: payload => dispatch(errorNotice(payload)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiepilogoFinanziamentoFindomestic)
